import IconBadge from '@/components/common/IconBadge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import BecomeMemberSvg from '@/public/illustrations/member.svg'
import { Award, Coins, Percent, Tag } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

export const BecomeMemberBlock = ({ className }: { className?: string }) => {
  const t = useTranslations()

  return (
    <Card className={cn('border-none', className)}>
      <CardContent className='flex flex-col space-y-4 lg:grid lg:grid-cols-2 lg:space-x-8'>
        <div className='flex flex-col justify-between space-y-4 lg:space-y-8'>
          <CardTitle>{t('become_a_first_member')}</CardTitle>

          <div className='flex justify-center pb-2 lg:pb-8'>
            <BecomeMemberSvg className='max-w-8/12 lg:max-w-7/12' />
          </div>
        </div>

        <div className='space-y-4 lg:space-y-8'>
          <p className='max-w-lg'>{t('become_a_member_description')}</p>

          <div className='space-y-2'>
            <div className='flex items-center space-x-2'>
              <IconBadge icon={Tag} />
              <p>{t('off_all_bookings')}</p>
            </div>

            <div className='flex items-center space-x-2'>
              <IconBadge icon={Award} />
              <p>{t('always_the_best_price')}</p>
            </div>

            <div className='flex items-center space-x-2'>
              <IconBadge icon={Coins} />
              <p>{t('earn_first_coins')}</p>
            </div>

            <div className='flex items-center space-x-2'>
              <IconBadge icon={Percent} />
              <p>{t('great_partner_offers')}</p>
            </div>
          </div>

          <div className='flex w-full justify-center'>
            <Link
              href='/login'
              className='border-secondary text-accent-foreground rounded-full border bg-[#F3EEE2] px-4 py-2 transition-opacity hover:opacity-50'
            >
              {t('become_a_member')}
            </Link>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
